import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  AuthActionTypes,
  LoginUser,
  LoginUserFailed,
  LoginUserSuccess,
  RegisterUser,
  RegisterUserFailed,
  RegisterUserSuccess,
  Token,
  TokenFailed,
  TokenSuccess,
  ValidateToken,
  ValidateTokenFailed,
  ValidateTokenSuccess,
  AppLoginInfo,
  AppLoginInfoFailed,
  AppLoginInfoSuccess
} from '../_actions/auth.actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { IdleService } from '../../services/idle.service';
import {
  UserData,
  TokenAPI,
  ValidateTokenResponse,
  AppLoginInfoResponse
} from '../_models/auth.models';

@Injectable()
export class AuthEffect {
  constructor(
    private actions: Actions,
    private service: AuthService,
    private idle: IdleService
  ) {}

  /**
   * Get token for user
   */
  token: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<Token>(AuthActionTypes.TOKEN),
      mergeMap((action: Token) =>
        this.service.token(action.payload, action.serverUrl).pipe(
          map(
            (payload: TokenAPI) => new TokenSuccess(payload),
            this.idle.reset()
          ),
          catchError((err) => of(new TokenFailed(err)))
        )
      )
    )
  );

  /**
   * Validate registeration user
   */
  validateToken: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<ValidateToken>(AuthActionTypes.VALIDATE_TOKEN),
      mergeMap((action: ValidateToken) =>
        this.service.validateToken(action.payload).pipe(
          map(
            (payload: ValidateTokenResponse) =>
              new ValidateTokenSuccess(payload)
          ),
          catchError((err) => of(new ValidateTokenFailed(err)))
        )
      )
    )
  );

  /**
   * Get App Login Info
   */
  appLoginInfo: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<AppLoginInfo>(AuthActionTypes.APP_LOGIN_INFO),
      mergeMap((action: AppLoginInfo) =>
        this.service.appLoginInfo(action.payload).pipe(
          map(
            (payload: AppLoginInfoResponse) =>
              new AppLoginInfoSuccess(payload)
          ),
          catchError((err) => of(new AppLoginInfoFailed(err)))
        )
      )
    )
  );

  /**
   * Register User
   */
  registerUser: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<RegisterUser>(AuthActionTypes.REGISTER_USER),
      mergeMap((action: RegisterUser) =>
        this.service.registerUser(action.payload).pipe(
          map((payload: any) => new RegisterUserSuccess(payload)),
          catchError((err) => of(new RegisterUserFailed(err)))
        )
      )
    )
  );

  /**
   * Login User
   */
  login: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType<LoginUser>(AuthActionTypes.LOGIN_USER),
      mergeMap((action: LoginUser) =>
        this.service.login(action.payload).pipe(
          map((payload: any) => new LoginUserSuccess(payload)),
          catchError((err) => of(new LoginUserFailed(err)))
        )
      )
    )
  );
}
